import { frontendURL } from 'dashboard/helper/URLHelper';
import CustomReportsViewer from './CustomReportsViewer.vue';
import CustomReportsHome from './CustomReportsHome.vue';
import CustomReportsSettings from './CustomReportsSettings.vue';
import CustomReportsList from './pages/reports/CustomReportsList.vue';
import CustomReportsCreate from './pages/reports/create/CustomReportsCreate.vue';
import CustomReportsShow from './pages/reports/CustomReportsShow.vue';
import CustomReportsEdit from './pages/reports/edit/CustomReportsEdit.vue';
import CustomDashboardShow from './pages/dashboards/CustomDashboardShow.vue';
import CustomDashboardsList from './pages/dashboards/CustomDashboardsList.vue';
import CustomDashboardCreate from './pages/dashboards/create/CustomDashboardCreate.vue';
import CustomDashboardEdit from './pages/dashboards/edit/CustomDashboardEdit.vue';
import EventDefinitionsList from './pages/eventDefinitions/EventDefinitionsList.vue';
import EventEnrichmentsList from './pages/enrichments/EventEnrichmentsList.vue';
import EventAutomationEditor from './pages/enrichments/edit/EventAutomationEditor.vue';

const meta = {
  permissions: ['administrator'],
};

const reportViewMeta = {
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports/wgpt'),
      component: CustomReportsViewer,
      meta: reportViewMeta,
      children: [
        {
          path: '',
          name: 'wgpt_reports',
          meta: reportViewMeta,
          component: CustomReportsHome,
        },
        {
          path: ':reportId',
          name: 'wgpt_reports_custom_show',
          component: CustomReportsShow,
          meta: reportViewMeta,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports/custom-dashboards'),
      component: CustomReportsViewer,
      meta: reportViewMeta,
      children: [
        {
          path: '',
          name: 'wgpt_reports_custom_dashboards',
          meta: reportViewMeta,
          redirect: to => ({
            name: 'wgpt_reports',
            params: { accountId: to.params.accountId },
            query: { tab: 'dashboards' },
          }),
        },
        {
          path: ':dashboardId',
          name: 'wgpt_reports_custom_dashboard_show',
          component: CustomDashboardShow,
          meta: reportViewMeta,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-reports/new'),
      name: 'wgpt_reports_settings_create',
      component: CustomReportsCreate,
      meta,
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/wgpt-reports/:reportId/edit'
      ),
      name: 'wgpt_reports_settings_edit',
      component: CustomReportsEdit,
      meta,
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/custom-reports/dashboards/new'
      ),
      name: 'wgpt_settings_custom_dashboards_create',
      component: CustomDashboardCreate,
      meta,
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/custom-reports/dashboards/:dashboardId/edit'
      ),
      name: 'wgpt_settings_custom_dashboards_edit',
      component: CustomDashboardEdit,
      meta,
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/wgpt-reports/enrichments/:eventAutomationId/edit'
      ),
      name: 'wgpt_reports_settings_enrichment_automation_editor',
      component: EventAutomationEditor,
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-reports'),
      component: CustomReportsSettings,
      meta,
      children: [
        {
          path: '',
          name: 'wgpt_reports_settings',
          redirect: { name: 'wgpt_reports_settings_list' },
          meta,
        },
        {
          path: 'reports',
          name: 'wgpt_reports_settings_list',
          component: CustomReportsList,
          meta,
        },
        {
          path: 'dashboards',
          name: 'wgpt_settings_custom_dashboards_list',
          component: CustomDashboardsList,
          meta,
        },
        {
          path: 'definitions',
          name: 'wgpt_reports_settings_event_definitions_list',
          component: EventDefinitionsList,
          meta,
        },
        {
          path: 'enrichments',
          name: 'wgpt_reports_settings_enrichments_list',
          component: EventEnrichmentsList,
          meta,
        },
      ],
    },
  ],
};
